import NavDrawer from "@/views/admin_components/NavDrawer/NavDrawer.vue";
import AppBar from "@/views/admin_components/AppBar/AppBar.vue";
import {Api} from "@/services/api";

export default {
    name: 'Coordinators',
    components: {AppBar, NavDrawer},
    data: () => ({
        coordinators: [],
    }),
    async created() {
        this.coordinators = await Api.get('admin/getCoordinators')
    }
}